/**
 * Popup suggerimento cambio lingua in base alla lingua del browser.
 * Config: #language-switch-popup-config (JSON)
 */
(function () {
  'use strict';

  var configEl = document.getElementById('language-switch-popup-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  if (!config.enabled) return;

  var STORAGE_KEY = config.storageKey || 'lang_switch_popup_ant45';
  var MANUAL_KEY = STORAGE_KEY + '_manual';

  /** Decodifica entità HTML da stringhe tradotte con filtro | t (es. &#39; → ') */
  function decodeHtmlEntities(str) {
    if (!str) return '';
    var el = document.createElement('textarea');
    el.innerHTML = str;
    return el.value;
  }

  function displayText(str) {
    return decodeHtmlEntities(str);
  }

  function hasDismissed() {
    try {
      if (window.localStorage && localStorage.getItem(STORAGE_KEY) === '1') {
        return true;
      }
    } catch (e) {}
    return document.cookie.indexOf(STORAGE_KEY + '=1') !== -1;
  }

  function hasManualLanguageChange() {
    try {
      return window.sessionStorage && sessionStorage.getItem(MANUAL_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setDismissed() {
    var days = parseInt(config.dismissDays, 10);
    if (isNaN(days) || days < 1) days = 365;

    try {
      if (window.localStorage) {
        localStorage.setItem(STORAGE_KEY, '1');
      }
    } catch (e) {}

    var expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = STORAGE_KEY + '=1; path=/; SameSite=Lax; expires=' + expires.toUTCString();
  }

  function normalizeList(list) {
    var result = [];
    if (!list || typeof list.length === 'undefined') return result;
    for (var i = 0; i < list.length; i++) {
      var v = list[i];
      if (v == null) continue;
      var s = String(v).toLowerCase().trim();
      if (!s) continue;
      if (result.indexOf(s) === -1) result.push(s);
    }
    return result;
  }

  function baseLang(str) {
    var s = (str || '').toLowerCase();
    return s.split('-')[0];
  }

  function filterExcludedLanguages(cfg) {
    var excluded = normalizeList(cfg.excludedLanguages);
    if (!excluded.length) return;

    var langs = cfg.languages || [];
    if (!langs.length) return;

    cfg.languages = langs.filter(function (lang) {
      var isoNorm = (lang.isoCode || '').toLowerCase();
      var isoBase = baseLang(isoNorm);
      return !excluded.some(function (ex) {
        var exNorm = String(ex).toLowerCase().trim();
        return isoNorm === exNorm || isoBase === baseLang(exNorm);
      });
    });
  }

  function isPathExcluded(cfg, pathname) {
    var list = cfg.excludedPaths || [];
    if (!list.length) return false;

    var pathNorm = pathname || '/';
    if (pathNorm.length > 1 && pathNorm.charAt(pathNorm.length - 1) === '/') {
      pathNorm = pathNorm.slice(0, -1);
    }

    return list.some(function (raw) {
      if (!raw) return false;
      var p = String(raw);
      if (p.length > 1 && p.charAt(p.length - 1) === '/') {
        p = p.slice(0, -1);
      }
      return pathNorm === p || pathNorm.indexOf(p + '/') === 0;
    });
  }

  function getPreferredLanguage(cfg) {
    var browserLangs = [];
    if (navigator.languages && navigator.languages.length) {
      browserLangs = navigator.languages.slice(0);
    } else if (navigator.language) {
      browserLangs = [navigator.language];
    }
    if (!browserLangs.length) return null;

    var available = cfg.languages || [];
    if (!available.length) return null;

    var currentIso = (cfg.currentLocale || '').toLowerCase();
    var currentBase = baseLang(currentIso);

    function isSameLanguage(code) {
      var norm = (code || '').toLowerCase();
      if (!norm) return false;
      return norm === currentIso || baseLang(norm) === currentBase;
    }

    for (var i = 0; i < browserLangs.length; i++) {
      var primary = browserLangs[i];
      if (!primary || isSameLanguage(primary)) continue;

      var primaryNorm = primary.toLowerCase();
      var primaryBase = baseLang(primaryNorm);

      for (var j = 0; j < available.length; j++) {
        var lang = available[j];
        var isoNorm = (lang.isoCode || '').toLowerCase();
        if ((isoNorm === primaryNorm || baseLang(isoNorm) === primaryBase) && !isSameLanguage(lang.isoCode)) {
          return lang;
        }
      }
    }

    return null;
  }

  function trapFocus(dialog) {
    var focusable = dialog.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return function () {};

    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    function onKeyDown(e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    dialog.addEventListener('keydown', onKeyDown);
    return function () {
      dialog.removeEventListener('keydown', onKeyDown);
    };
  }

  function closeDialog(dialog, releaseFocus) {
    if (releaseFocus) releaseFocus();
    if (dialog.open) dialog.close();
    dialog.remove();
  }

  function buildPopup(cfg, preferredLang) {
    if (!preferredLang || !cfg.languages || !cfg.languages.length) return;

    var dialog = document.createElement('dialog');
    dialog.className = 'dialog-lang-switch';
    dialog.setAttribute('data-nosnippet', '');
    dialog.setAttribute('aria-labelledby', 'dialog-lang-switch-title');

    var inner = document.createElement('div');
    inner.className = 'dialog-lang-switch__inner';

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'dialog-lang-switch__close';
    close.setAttribute('aria-label', displayText(cfg.closeAriaLabel) || 'Close');
    close.innerHTML = '&times;';

    var title = document.createElement('p');
    title.id = 'dialog-lang-switch-title';
    title.className = 'dialog-lang-switch__title';
    title.textContent = displayText(cfg.title);

    var text = document.createElement('p');
    text.className = 'dialog-lang-switch__text';
    text.textContent = displayText(preferredLang.message);

    var selectWrapper = document.createElement('div');
    selectWrapper.className = 'dialog-lang-switch__select-wrapper';

    var selectLabel = document.createElement('label');
    selectLabel.className = 'dialog-lang-switch__select-label';
    var selectId = 'dialog-lang-switch-select';
    selectLabel.setAttribute('for', selectId);
    selectLabel.textContent = displayText(cfg.selectLabel);

    var select = document.createElement('select');
    select.id = selectId;
    select.className = 'dialog-lang-switch__select';

    cfg.languages.forEach(function (lang) {
      var opt = document.createElement('option');
      opt.value = lang.isoCode;
      opt.textContent = displayText(lang.name);
      if (lang.isoCode === preferredLang.isoCode) {
        opt.selected = true;
      }
      select.appendChild(opt);
    });

    selectWrapper.appendChild(selectLabel);
    selectWrapper.appendChild(select);

    var buttons = document.createElement('div');
    buttons.className = 'dialog-lang-switch__buttons';

    var yesBtn = document.createElement('button');
    yesBtn.type = 'button';
    yesBtn.className = 'dialog-lang-switch__btn dialog-lang-switch__btn--primary';
    yesBtn.textContent = displayText(cfg.yesLabel) || 'OK';

    var noBtn = document.createElement('button');
    noBtn.type = 'button';
    noBtn.className = 'dialog-lang-switch__btn dialog-lang-switch__btn--secondary';
    noBtn.textContent = displayText(cfg.noLabel) || 'No';

    function dismiss() {
      setDismissed();
      closeDialog(dialog, releaseFocus);
    }

    close.addEventListener('click', dismiss);
    noBtn.addEventListener('click', dismiss);

    yesBtn.addEventListener('click', function () {
      setDismissed();
      var selectedIso = select.value;
      var form = document.getElementById('popup-language-localization-form');
      if (!form) {
        closeDialog(dialog, releaseFocus);
        return;
      }
      var input = form.querySelector('input[name="language_code"]');
      if (input) input.value = selectedIso;
      form.submit();
    });

    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      dismiss();
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) dismiss();
    });

    buttons.appendChild(noBtn);
    buttons.appendChild(yesBtn);

    inner.appendChild(close);
    inner.appendChild(title);
    inner.appendChild(text);
    inner.appendChild(selectWrapper);
    inner.appendChild(buttons);
    dialog.appendChild(inner);

    document.body.appendChild(dialog);
    var releaseFocus = trapFocus(dialog);
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    close.focus();
  }

  function trackManualLanguageChanges() {
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.matches) return;
        if (!form.matches('form[action*="/localization"]')) return;
        if (form.querySelector('[name="language_code"]')) {
          try {
            sessionStorage.setItem(MANUAL_KEY, '1');
          } catch (err) {}
        }
      },
      true
    );
  }

  function init() {
    trackManualLanguageChanges();

    if (hasDismissed() || hasManualLanguageChange()) return;

    filterExcludedLanguages(config);

    if (isPathExcluded(config, window.location.pathname || '/')) return;
    if (!config.languages || config.languages.length < 2) return;

    var preferredLang = getPreferredLanguage(config);
    if (!preferredLang) return;

    var delay = parseInt(config.delayMs, 10);
    if (isNaN(delay) || delay < 0) delay = 2000;

    window.setTimeout(function () {
      if (hasDismissed() || hasManualLanguageChange()) return;
      buildPopup(config, preferredLang);
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
